import { render, staticRenderFns } from "./BranchTimeForm.vue?vue&type=template&id=698eb4a0&"
import script from "./BranchTimeForm.vue?vue&type=script&lang=js&"
export * from "./BranchTimeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports